export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtTablpoz';
export const NAME = 'TabulkovaPozice';
